import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';
import { fetchData } from './state/slices/data';
import { setUpBrowserListeners } from './state/slices/browserUtils';

import Footer from './views/footer';
import Header from './views/header';
import Content from './views/content';
import Annotation from './views/annotation';
import Annotation2 from './views/annotation2';
import ChartBar from './views/chartbar';

import store from './state/store';

const container = document.getElementById('foot');
const root = createRoot(container);

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div className="content-wrap">
      <Header />
      <ChartBar />
      <Annotation />
      <Content />
      <Annotation2 />
      <Footer />
    </div>
  </Provider>
);

root.render(element);

/* Start up functions */
setUpBrowserListeners();
store.dispatch(fetchData());
